import { HEIGHT_MULTIPLIER, WIDTH_MULTIPLIER } from './consts';
import type { SpriteSheetItem } from './types';

type SpriteSheet = Record<string, SpriteSheetItem>;

export const MINIMAP: SpriteSheetItem = {
  x: 792 * WIDTH_MULTIPLIER,
  y: 475 * HEIGHT_MULTIPLIER,
  w: 298 * WIDTH_MULTIPLIER,
  h: 202 * HEIGHT_MULTIPLIER,
};

export const BACKGROUND: SpriteSheet = {
  HILLS: { x: 0, y: 0, w: 3479, h: 696 },
};

export const TREES: SpriteSheet = {
  TREE1: {
    x: 0,
    y: 0,
    w: 2 * 255,
    h: 2 * 378,
  },
  TREE2: {
    x: 2 * 265,
    y: 0,
    w: 2 * 120,
    h: 2 * 380,
  },
  TREE3: {
    x: 2 * 395,
    y: 0,
    w: 2 * 166,
    h: 2 * 250,
  },
  TREE4: {
    x: 2 * 571,
    y: 0,
    w: 2 * 210,
    h: 2 * 295,
  },
  TREE5: {
    x: 2 * 791,
    y: 0,
    w: 2 * 145,
    h: 2 * 311,
  },
  TREE6: {
    x: 2 * 946,
    y: 0,
    w: 2 * 153,
    h: 2 * 282,
  },
  TREE7: {
    x: 2 * 1109,
    y: 0,
    w: 2 * 204,
    h: 2 * 420,
  },
  TREE8: {
    x: 2 * 1323,
    y: 0,
    w: 2 * 120,
    h: 2 * 260,
  },
};
export const BILLBOARD: SpriteSheetItem = {
  x: 2906,
  y: 0,
  w: 239,
  h: 564,
};

export const BILLBOARDS = [BILLBOARD];
export const PLANTS = Object.values(TREES);
